import { ref, onMounted } from 'vue'
import { ItemWrapper } from '@/wrappers'
import { UserIcon } from '@heroicons/vue/24/outline'
import type { ContactPerson, FormData, FormInfo, DataFile, FormSelectOption, RequestType } from '@/interfaces'

export function useContactPerson(skipLoading: boolean = false) {

    const baseForm: FormData = {
        company: null,
        name: null
    };

    const wrapper = new ItemWrapper<ContactPerson>("contact-persons");

    const empty = structuredClone(baseForm);

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const info = ref<FormInfo>();
    const contactPersons = ref<ContactPerson[]>([]);
    const contactPersonOptions = ref<FormSelectOption[]>([]);

    async function addContactPerson(): Promise<void> {
        request.value = {...request.value , error: null , response: null , isLoading: !request.value.isLoading};

        await wrapper.addItem(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.data = {...empty};
        request.value.isLoading = !request.value.isLoading;
    }

    function getAsFormOptions(): void {
        contactPersonOptions.value = contactPersons.value.map(contactPerson => {
            return {
                value: contactPerson.id,
                label: contactPerson.name,
                icon: UserIcon
            }
        });
    }

    async function getContactPersons(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getItems().then((data) => contactPersons.value = data);

        getAsFormOptions();
        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: null,
            data: JSON.stringify(request.value.data)
        }
    }

    onMounted(() => {
        if (skipLoading) return;

        getContactPersons();
    });

    return {
        info,
        request,
        contactPersons,
        contactPersonOptions,
        getInfo,
        addContactPerson,
        getContactPersons
    }
}